module.exports = __webpack_public_path__ + "static/media/Anlook.6aec41b7.png";